// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/Quicksand-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: quicksend_bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* body { # This Bg is a static blue
background-image: url(/public/images/Attendance\\ web.png);
} */

body {
	background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
	background-size: 400% 400%;
	animation: gradient 15s ease infinite;
	height: 100vh;
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

h3,h5,h4 {
  color: black;
  font-family: quicksend_bold;
  font-size: 17px;	
}

.flex_container{
  display: flex;
  gap: 15px;
  justify-content: space-between;
  margin-top: 15px;
  padding-top: 30px;
  
}
.hero_section{
  margin-left: auto;
  margin-right: auto;
  width: 95%;
}
.card{
  border-radius: 10px;
  height: 570px;
  width: 30%;
  padding-left: 20px;
  padding-right: 20px;
  margin-right: 10px;
  overflow-y: visible;
  background-color: white;
  border-top: 1px solid rgba(255,255,255,0.9);
  border-left: 1px solid rgba(255,255,255,0.9);
  border-right: 1px solid rgba(180,180,180,0.6);
  border-bottom: 1px solid rgba(180,180,180,0.6);
  box-shadow: 6px 6px 16px rgba(0,0,0,0.35), -2px -2px 6px rgba(255,255,255,0.8);
}

.user_name{
  background-color: whitesmoke;
  border: 1px solid lightblue;
  margin-bottom: 10px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-family: quicksend_bold;
  font-size: 13px;
  padding-left: 40px;
  border-radius: 5px;
}

/* Walk-in / paid per class - Yellow border */
.user_name_walkin {
  background-color: whitesmoke;
  border: 2px solid #ffd700;
  margin-bottom: 10px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-family: quicksend_bold;
  font-size: 13px;
  padding-left: 40px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(255, 215, 0, 0.4);
}

/* Expired membership - Red border */
.user_name_expired {
  background-color: whitesmoke;
  border: 2px solid #dc3545;
  margin-bottom: 10px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-family: quicksend_bold;
  font-size: 13px;
  padding-left: 40px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(220, 53, 69, 0.4);
}

/* Active member - Green border */
.user_name_active {
  background-color: whitesmoke;
  border: 2px solid #1FD655;
  margin-bottom: 10px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-family: quicksend_bold;
  font-size: 13px;
  padding-left: 40px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(31, 214, 85, 0.3);
}

/* legacy — kept so old references don't break visually */
.user_name_expiring {
  background-color: whitesmoke;
  border: 2px solid #dc3545;
  margin-bottom: 10px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-family: quicksend_bold;
  font-size: 13px;
  padding-left: 40px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(220, 53, 69, 0.4);
}


.userlist-animate {
  z-index: 10;
  background: transparent;

  border: 1px solid lightblue;
  margin-bottom: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: quicksend_bold;
  font-size: 13px;
  padding-left: 40px;
  border-radius: 5px;
}
.userlist-animate:before {
  content: "";
  position: absolute;
  transition: opacity .35s ease-in-out;
 -moz-transition: opacity .35s ease-in-out;
 -webkit-transition: opacity .35s ease-in-out;
  top:0; left: 0; right: 0; bottom: 0; z-index:-1; /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
  background: radial-gradient(ellipse at center, #ffffff 40%,#e9eae9 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}
.userlist-animate:hover:before {
  opacity: 0;
}
.userlist-animate:after {
  content: ""; opacity: 0;
  transition: opacity .35s ease-in-out;
 -moz-transition: opacity .35s ease-in-out;
 -webkit-transition: opacity .35s ease-in-out;
  position: absolute;
  top:0; left: 0; right: 0; bottom: 0; z-index:-1; /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
  background: radial-gradient(ellipse at center, #ffffff 80%,#e9eae9 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}
.userlist-animate:hover:after {
  opacity: 1;
}

.circle{
  background-color: #8B2FC9;
  color: #ffff;
  width: 70px;
  height: 70px;
  align-items: center;
  display: flex;
  justify-content: center;
  font-family: quicksend_bold;
  font-size: 20px;
  border-radius: 50%;
}

.numbers {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top:60px !important;
}
.num_flex{
  display: flex;
  justify-content: space-around;
}
.btn_enter{
  height: 44px;
  color: #fff;
  background-color: #0984E3;
  padding-left: 5px;
  border-radius: 5px;
  padding-top:10px ;
  padding-right: 5px;
  font-family: quicksend_bold;
}
.react-tel-input {
  margin-left: auto;
  margin-right: auto;
  width: 60%;
  font-family: quicksend_bold !important;
}


/* PopUps */

.popup{
  width: 440px;
  border-top: 10px solid #1FD655;
  border: 3px solid #1FD655;
  background-color: #fff;
  margin-left: auto;
  margin-right: auto;
  border-radius: 25px;
}
.quicksend_bold{
  font-family: quicksend_bold;
}

.text-center{
  text-align: center;
  margin-top: -45px;
  margin-bottom: 20px;
}
.popup_text{
  text-align: center;
  padding-bottom: 30px;
}
.footer{
  display: inherit;
  padding-top: 50px;
  font-size: x-small;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
}

@media screen and (max-width: 1024px) {
  .hero_section {
    width: 98%;
  }
  .card {
    width: 30%;
    padding-left: 10px;
    padding-right: 10px;
    height: 570px;
  }
  .circle {
    width: 55px;
    height: 55px;
    font-size: 16px;
  }
  .numbers {
    width: 90%;
    margin-left: 2%;
  }
  .flex_container {
    gap: 10px;
  }
}

.header_bar {
  display: grid;
  grid-template-columns: 70px 1fr 70px;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.header_date {
  text-align: center;
  font-family: quicksend_bold;
  font-size: 20px;
  font-weight: bold;
  color: black;
}

.card_keypad {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center;
  height: 680px !important;
  background-color: white;
}












`, "",{"version":3,"sources":["webpack://./src/css/index.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,4CAA0C;AAC5C;;AAEA;;GAEG;;AAEH;CACC,uEAAuE;CACvE,0BAA0B;CAC1B,qCAAqC;CACrC,aAAa;AACd;;AAEA;CACC;EACC,2BAA2B;CAC5B;CACA;EACC,6BAA6B;CAC9B;CACA;EACC,2BAA2B;CAC5B;AACD;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,4CAA4C;EAC5C,6CAA6C;EAC7C,8CAA8C;EAC9C,8EAA8E;AAChF;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,oCAAoC;AACpC;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,iCAAiC;AACjC;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,yDAAyD;AACzD;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;;AAGA;EACE,WAAW;EACX,uBAAuB;;EAEvB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;CACrC,yCAAyC;CACzC,4CAA4C;EAC3C,KAAK,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS,EAAE,UAAU,EACqC,aAAa,EACX,4BAA4B;EAClH,wEAAwE,EAAE,qDAAqD;AACjI;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW,EAAE,UAAU;EACvB,oCAAoC;CACrC,yCAAyC;CACzC,4CAA4C;EAC3C,kBAAkB;EAClB,KAAK,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS,EAAE,UAAU,EACqC,aAAa,EACX,4BAA4B;EAClH,wEAAwE,EAAE,qDAAqD;AACjI;AACA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,sCAAsC;AACxC;;;AAGA,WAAW;;AAEX;EACE,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;AACzB","sourcesContent":["@font-face {\n  font-family: quicksend_bold;\n  src: url(/public/fonts/Quicksand-Bold.ttf);\n}\n\n/* body { # This Bg is a static blue\nbackground-image: url(/public/images/Attendance\\ web.png);\n} */\n\nbody {\n\tbackground: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);\n\tbackground-size: 400% 400%;\n\tanimation: gradient 15s ease infinite;\n\theight: 100vh;\n}\n\n@keyframes gradient {\n\t0% {\n\t\tbackground-position: 0% 50%;\n\t}\n\t50% {\n\t\tbackground-position: 100% 50%;\n\t}\n\t100% {\n\t\tbackground-position: 0% 50%;\n\t}\n}\n\nh3,h5,h4 {\n  color: black;\n  font-family: quicksend_bold;\n  font-size: 17px;\t\n}\n\n.flex_container{\n  display: flex;\n  gap: 15px;\n  justify-content: space-between;\n  margin-top: 15px;\n  padding-top: 30px;\n  \n}\n.hero_section{\n  margin-left: auto;\n  margin-right: auto;\n  width: 95%;\n}\n.card{\n  border-radius: 10px;\n  height: 570px;\n  width: 30%;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-right: 10px;\n  overflow-y: visible;\n  background-color: white;\n  border-top: 1px solid rgba(255,255,255,0.9);\n  border-left: 1px solid rgba(255,255,255,0.9);\n  border-right: 1px solid rgba(180,180,180,0.6);\n  border-bottom: 1px solid rgba(180,180,180,0.6);\n  box-shadow: 6px 6px 16px rgba(0,0,0,0.35), -2px -2px 6px rgba(255,255,255,0.8);\n}\n\n.user_name{\n  background-color: whitesmoke;\n  border: 1px solid lightblue;\n  margin-bottom: 10px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-family: quicksend_bold;\n  font-size: 13px;\n  padding-left: 40px;\n  border-radius: 5px;\n}\n\n/* Walk-in / paid per class - Yellow border */\n.user_name_walkin {\n  background-color: whitesmoke;\n  border: 2px solid #ffd700;\n  margin-bottom: 10px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-family: quicksend_bold;\n  font-size: 13px;\n  padding-left: 40px;\n  border-radius: 5px;\n  box-shadow: 0 0 5px rgba(255, 215, 0, 0.4);\n}\n\n/* Expired membership - Red border */\n.user_name_expired {\n  background-color: whitesmoke;\n  border: 2px solid #dc3545;\n  margin-bottom: 10px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-family: quicksend_bold;\n  font-size: 13px;\n  padding-left: 40px;\n  border-radius: 5px;\n  box-shadow: 0 0 5px rgba(220, 53, 69, 0.4);\n}\n\n/* Active member - Green border */\n.user_name_active {\n  background-color: whitesmoke;\n  border: 2px solid #1FD655;\n  margin-bottom: 10px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-family: quicksend_bold;\n  font-size: 13px;\n  padding-left: 40px;\n  border-radius: 5px;\n  box-shadow: 0 0 5px rgba(31, 214, 85, 0.3);\n}\n\n/* legacy — kept so old references don't break visually */\n.user_name_expiring {\n  background-color: whitesmoke;\n  border: 2px solid #dc3545;\n  margin-bottom: 10px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-family: quicksend_bold;\n  font-size: 13px;\n  padding-left: 40px;\n  border-radius: 5px;\n  box-shadow: 0 0 5px rgba(220, 53, 69, 0.4);\n}\n\n\n.userlist-animate {\n  z-index: 10;\n  background: transparent;\n\n  border: 1px solid lightblue;\n  margin-bottom: 10px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-family: quicksend_bold;\n  font-size: 13px;\n  padding-left: 40px;\n  border-radius: 5px;\n}\n.userlist-animate:before {\n  content: \"\";\n  position: absolute;\n  transition: opacity .35s ease-in-out;\n -moz-transition: opacity .35s ease-in-out;\n -webkit-transition: opacity .35s ease-in-out;\n  top:0; left: 0; right: 0; bottom: 0; z-index:-1;\n  background: -moz-radial-gradient(center, ellipse cover, #ffffff 40%, #e9eae9 100%); /* FF3.6-15 */\n  background: -webkit-radial-gradient(center, ellipse cover, #ffffff 40%,#e9eae9 100%); /* Chrome10-25,Safari5.1-6 */\n  background: radial-gradient(ellipse at center, #ffffff 40%,#e9eae9 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n}\n.userlist-animate:hover:before {\n  opacity: 0;\n}\n.userlist-animate:after {\n  content: \"\"; opacity: 0;\n  transition: opacity .35s ease-in-out;\n -moz-transition: opacity .35s ease-in-out;\n -webkit-transition: opacity .35s ease-in-out;\n  position: absolute;\n  top:0; left: 0; right: 0; bottom: 0; z-index:-1;\n  background: -moz-radial-gradient(center, ellipse cover, #ffffff 80%, #e9eae9 100%); /* FF3.6-15 */\n  background: -webkit-radial-gradient(center, ellipse cover, #ffffff 80%,#e9eae9 100%); /* Chrome10-25,Safari5.1-6 */\n  background: radial-gradient(ellipse at center, #ffffff 80%,#e9eae9 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n}\n.userlist-animate:hover:after {\n  opacity: 1;\n}\n\n.circle{\n  background-color: #8B2FC9;\n  color: #ffff;\n  width: 70px;\n  height: 70px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  font-family: quicksend_bold;\n  font-size: 20px;\n  border-radius: 50%;\n}\n\n.numbers {\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top:60px !important;\n}\n.num_flex{\n  display: flex;\n  justify-content: space-around;\n}\n.btn_enter{\n  height: 44px;\n  color: #fff;\n  background-color: #0984E3;\n  padding-left: 5px;\n  border-radius: 5px;\n  padding-top:10px ;\n  padding-right: 5px;\n  font-family: quicksend_bold;\n}\n.react-tel-input {\n  margin-left: auto;\n  margin-right: auto;\n  width: 60%;\n  font-family: quicksend_bold !important;\n}\n\n\n/* PopUps */\n\n.popup{\n  width: 440px;\n  border-top: 10px solid #1FD655;\n  border: 3px solid #1FD655;\n  background-color: #fff;\n  margin-left: auto;\n  margin-right: auto;\n  border-radius: 25px;\n}\n.quicksend_bold{\n  font-family: quicksend_bold;\n}\n\n.text-center{\n  text-align: center;\n  margin-top: -45px;\n  margin-bottom: 20px;\n}\n.popup_text{\n  text-align: center;\n  padding-bottom: 30px;\n}\n.footer{\n  display: inherit;\n  padding-top: 50px;\n  font-size: x-small;\n  text-align: center;\n  font-family: 'Times New Roman', Times, serif;\n}\n\n@media screen and (max-width: 1024px) {\n  .hero_section {\n    width: 98%;\n  }\n  .card {\n    width: 30%;\n    padding-left: 10px;\n    padding-right: 10px;\n    height: 570px;\n  }\n  .circle {\n    width: 55px;\n    height: 55px;\n    font-size: 16px;\n  }\n  .numbers {\n    width: 90%;\n    margin-left: 2%;\n  }\n  .flex_container {\n    gap: 10px;\n  }\n}\n\n.header_bar {\n  display: grid;\n  grid-template-columns: 70px 1fr 70px;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.header_date {\n  text-align: center;\n  font-family: quicksend_bold;\n  font-size: 20px;\n  font-weight: bold;\n  color: black;\n}\n\n.card_keypad {\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n  align-items: center;\n  height: 680px !important;\n  background-color: white;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
